import { Injectable } from '@angular/core';
import { QueryOptions, QueryResults, RecordTypes } from '@mode/shared/data-access-algolia';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, from, map, of, switchMap } from 'rxjs';
import * as EmailSearchActions from './email-search.actions';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { SearchClientService } from '@mode/algolia/domain';

@Injectable()
export class EmailSearchEffects {
  searchEmail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmailSearchActions.searchEmail),
      switchMap(({ searchText, organization }) => {
        const queryPayload: QueryOptions<keyof RecordTypes> = {
          query: searchText,
          indexes: ['userEmail'],
          perPage: 20,
          filters: `organization_${organization},organization_${organization}_active`,
        };

        return from(this.searchClientService.query(queryPayload)).pipe(
          map((response: QueryResults<keyof RecordTypes>) =>
            EmailSearchActions.searchEmailSuccess({ searchResults: response.userEmail })
          ),
          catchError(() => of(EmailSearchActions.searchEmailFailure({ error: 'Error validating email' })))
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private searchClientService: SearchClientService
  ) {}
}
